import { render, staticRenderFns } from "./dangjian.vue?vue&type=template&id=9281b8d8&scoped=true"
import script from "./dangjian.vue?vue&type=script&lang=js"
export * from "./dangjian.vue?vue&type=script&lang=js"
import style0 from "./dangjian.vue?vue&type=style&index=0&id=9281b8d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9281b8d8",
  null
  
)

export default component.exports